import { InfoDialog } from '@occc-app/design-system';

export const InheritedLocationInfoDialog = ({
  open,
  onClose,
}: {
  open: boolean;
  onClose: (event: React.MouseEvent<HTMLElement>) => void;
}) => (
  <InfoDialog open={open} onClose={onClose} dialogTitle='Location Cannot Be Removed'>
    This location was added to your network by an admin. Please contact your admin to remove it from
    the preceding network.
  </InfoDialog>
);
